import { FC } from 'react';

import { useReferenceData } from '../../../hooks/reduxHooks';

const PlatformCell: FC<{ value: PlatformCode }>  = ({ value }): any => {
	const platforms = useReferenceData('platforms') as PlatformData[];
	return (
		platforms?.find((p) => p.platform_code === value)?.platform_name ?? null
	);
};

export default PlatformCell;
